const SIZES = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const ERRORS = {
  negativeNumber: '[FormatBytes] Bytes value should be positive',
};

const format = (bytes: number | undefined): string => {
  if (bytes === undefined) {
    return '-';
  }

  if (bytes === -1) {
    return 'N/A';
  }

  if (bytes < 0) {
    throw new Error(ERRORS.negativeNumber);
  }

  let exponent = 0;

  if (bytes !== 0) {
    exponent = Math.floor(Math.log(bytes) / Math.log(1024));
  }

  if (exponent >= SIZES.length) {
    exponent = SIZES.length - 1;
  }

  const formattedValue = (bytes / Math.pow(1024, exponent))
    .toFixed(1)
    .replace('.0', '');

  return `${formattedValue}${SIZES[exponent]}`;
};

export default {
  format,
};
